import * as ethers from 'ethers';
import { ConfigJsonType } from '../../model/configJsonType';



export const isLocalStorageAvailable = async () => {
    if (typeof localStorage !== 'undefined') {
        try {
            localStorage.setItem('dummy', '1');
            if (localStorage.getItem('dummy') === '1') {
                localStorage.removeItem('dummy');
                return true;
            } else {
                return false;
            }
        } catch(e) {
        return false;
        }
    } else {
        return false;
    }
}




export const getuseraddress = () =>{
    let useraddressmode:string = "localstorage_addressofmine";
    if (useraddressmode === "justtest_holder"){
        //address who have sample NFT (0x077db1ed249E453E3e9B2A85eef518D64De1a275)
        return "0x600533048e815Fcf782fc9506C345e4aDA059C19";
    }else if (useraddressmode === "justtest_nonholder"){
        //address who have NOT sample NFT (0x077db1ed249E453E3e9B2A85eef518D64De1a275)
        return "0xd8da6bf26964af9d7eed9e03e53415d37aa96045";
    } else {
        //--------------production--------------------
        if(localStorage.getItem('addressofmineMM')){
            console.log("return addressofmineMM")
            return localStorage.getItem('addressofmineMM');
        } else  if(localStorage.getItem("addressofmine")){
            console.log("return addressofmine")
            return localStorage.getItem("addressofmine");
        } else if(localStorage.getItem('privateKey')) {
            console.log("return privatekey address")
            return new ethers.Wallet(localStorage.getItem('privateKey')).address;
        } else {
            console.log("return nothing")
            return "";
        }
    }
}



const isValidPrivateKey = (privateKey:string) => {
    //0xアドレス判定
    try {
        ethers.utils.getAddress(privateKey);
        return true;
    }catch (error) {
        return false;
    }
}

//cookeyから値を取得
const getCookie = (name:string) => {
    const cookieArray = document.cookie.split(';');
    const nameEQ = name + '=';

    for (let i = 0; i < cookieArray.length; i++) {
        let c = cookieArray[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEQ) === 0) {
            return c.substring(nameEQ.length, c.length);
        }
    }
    return null;
}

const setCookey = async ( _privatekey:string ) => {
    try {
        //開発
        // const response = await fetch("https://cookie.sushitop.io/setCookey", {
        //本番
        const response = await fetch("https://www.sushitop.io/setCookey", {
            method: "POST",
            mode: "cors", // クロスオリジンリクエストを許可
            credentials: "include", // Cookieを含めるために必要
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ privateKey: _privatekey })
        });
    
        if (response.ok) {
            console.log(`Cookey has been set. value is ${getCookie("cookey")}`);
        } else {
            console.error("Error setting cookie");
        }
    } catch (error) {
        console.log(error);
    }
}


export const switchAndCreateBrowserWallet = async(nav3:any) => {
    if (!isLocalStorageAvailable()) {alert("非対応ブラウザです。ブラウザを変更して再度お試しください。"); return;}
    let useraddress:string;
    const cookeyData = getCookie("cookey");

    if(!(localStorage.getItem('privateKey'))){
        if (!cookeyData) {
            //ブラウザウォレットなしcookieなし
            console.log("create new privatekey");
            const wallet = ethers.Wallet.createRandom();
    
            localStorage.setItem('privateKey', wallet.privateKey);
            localStorage.setItem("walletAddressFromPK",wallet.address);
            localStorage.setItem('currentStatus','browserWallet');
            useraddress = wallet.address;

            setCookey(wallet.privateKey);
        }else{
            //ブラウザウォレットなしcookieあり
            localStorage.setItem('privateKey', cookeyData);
            localStorage.setItem("walletAddressFromPK",new ethers.Wallet(cookeyData).address);
            localStorage.setItem('currentStatus','browserWallet');
        }
    }else{
        //ブラウザウォレットありcookieなし
        if (!cookeyData) {
            setCookey(localStorage.getItem(`privateKey`));
        }
    }
    nav3;
};





// //⏬ブラウザウォレットを生成した後にバックアップカードページに移動
// export const switchAndCreateBrowserWallet = async(nav3:any) => {
//     if (!isLocalStorageAvailable()) {alert("非対応ブラウザです。ブラウザを変更して再度お試しください。"); return;}
//     let useraddress:string;

//     if(!(localStorage.getItem('privateKey'))){
//         //⏬ブラウザウォレットの作成(プライベートキーはローカルストレージにセット)
//         console.log("create new privatekey");
//         const wallet = ethers.Wallet.createRandom();

//         // //↓秘密鍵暗号化
//         // const privateKeyCrypto = crypto.AES.encrypt(`${wallet.privateKey}`, 'nft');
//         // console.log(`privateKeyCrypto :  ${privateKeyCrypto.toString()}`);
//         // localStorage.setItem('privateKeyCrypto', `${privateKeyCrypto.toString()}`);
//         // //↓秘密鍵復号化
//         // const privateKeyDecrypted = crypto.AES.decrypt(`U2FsdGVkX1+aFKv2MeJ1IJlfQIBP8G68ClmXbrc49kA=`, 'nft');
//         // console.log(`decrypted :  ${privateKeyDecrypted.toString(crypto.enc.Utf8)}`);

//         localStorage.setItem('privateKey', wallet.privateKey);
//         localStorage.setItem("walletAddressFromPK",wallet.address);
//         localStorage.setItem('currentStatus','browserWallet');
//         useraddress = wallet.address;
//     }

//     // if (!(localStorage.getItem('privateKey')) || !(localStorage.getItem('privateKeyCrypto'))) {
//     //     //⏬ブラウザウォレットの作成(プライベートキーはローカルストレージにセット)
//     //     console.log("create new privatekey");
//     //     const wallet = ethers.Wallet.createRandom();

//     //     //↓秘密鍵暗号化
//     //     const privateKeyCrypto = crypto.AES.encrypt(`${wallet.privateKey}`, 'nft');
//     //     console.log(`privateKeyCrypto :  ${privateKeyCrypto.toString()}`);
//     //     localStorage.setItem('privateKeyCrypto', `${privateKeyCrypto.toString()}`);

//     //     localStorage.setItem("walletAddressFromPK",wallet.address);
//     //     localStorage.setItem('currentStatus','browserWallet');
//     //     useraddress = wallet.address;
//     // }
//     nav3;
// };



//ユーザーの使用デバイスプラットフォームの取得
export const getMobileOS = () => {
    const ua = navigator.userAgent;
    const browserLanguage = navigator.language;
    if(localStorage.getItem(`load_browser`)){return;}
    if (/android/i.test(ua)) {
        localStorage.setItem(`load_browser`,`done`);
        if (browserLanguage === `ja` || browserLanguage === `ja-JP`) {
            alert(`デフォルトのChromeブラウザで開いてください。\n\n その他のブラウザの場合、NFTを正常に保存できない場合があります。`);
        }else{
            alert(`Please open in the default Chrome browser.\n\n If you use other browsers, you may not be able to save NFTs properly.`);
        }
        return "Android";
    }
    else if ((/iPad|iPhone|iPod/.test(ua))){
        localStorage.setItem(`load_browser`,`done`);
        if (browserLanguage === `ja` || browserLanguage === `ja-JP`) {
            alert(`デフォルトのsafariブラウザで開いてください。\n\n その他のブラウザの場合、NFTを正常に保存できない場合があります。`);
        }else{
            alert(`Please open in the default safari browser.\n\n If you use other browsers, you may not be able to save NFTs properly.`);
        }
        return "iOS";
    }
    return "Other";
}
  
  
  



//配布ページ設定情報取得
export const getConfigJson = async ()=>{
    let res:Response;
    res = await fetch(`${location.pathname.replace("index.html", "config.json")}`);
    let data:any;
    try {
        data = await res.json();
    } catch (error) {
        throw new Error("not_found_config-json");
    }


    let walletTypeArrayFromJson:string[] = [];
    if (data.walletTypeArray) {
        data.walletTypeArray.forEach((value: any) => {
            walletTypeArrayFromJson.push(value);
        });
    }
    const configJson : ConfigJsonType = {
        lang:`${data.lang?data.lang:`ja`}`,
        isGachaMovie:`${data.isGachaMovie?data.isGachaMovie:`no`}`,
        isTweetButton:`${data.isTweetButton?data.isTweetButton:`no`}`,
        isGetNFTagainButton:`${data.isGetNFTagainButton?data.isGetNFTagainButton:`no`}`,
        walletTypeArray: (walletTypeArrayFromJson.length > 0 ) ? walletTypeArrayFromJson:["browserWallet"],
        insertTweetText:`${data.insertTweetText?data.insertTweetText:``}`,
        web3layerUrl:`${data.web3layerUrl?data.web3layerUrl:``}`,
        nftReceivingMovieUrl:`${data.nftReceivingMovieUrl?data.nftReceivingMovieUrl:``}`,

        nftReceivingImage:{
            url:`${data.nftReceivingImage?data.nftReceivingImage.url:``}`,
            isBlurred:data.nftReceivingImage?data.nftReceivingImage.isBlurred:true,
        },
        isMyAppLink:data.isMyAppLink === false?false:true,
        backgroundImage:`${data.backgroundImage?data.backgroundImage:`https://arweave.net/dk4iegm681EFAvgPECJOBte3kcLcjzCGJAePSo29jsg`}`,
    }

    console.log(configJson);
    return configJson;
}